import React from 'react'
import { Box, Heading, Text, VStack } from '@chakra-ui/react'
import { Research } from '../../../../types/Research'
import { formatDate } from '../../../../utils/researchHelpers'

interface ResearchContentProps {
  research: Research
}

const ResearchContent: React.FC<ResearchContentProps> = ({ research }) => {
  return (
    <VStack align='start' spacing={6}>
      {/* Researcher Notes */}
      {research.researcherNotes && (
        <Box>
          <Heading size='md' mb={3}>
            Researcher Notes
          </Heading>
          <Text
            lineHeight='1.6'
            whiteSpace='pre-wrap'
            fontStyle='italic'
            color='gray.700'
            bg='gray.50'
            p={4}
            borderRadius='md'
            borderLeft='4px solid'
            borderLeftColor='blue.400'
          >
            {research.researcherNotes}
          </Text>
        </Box>
      )}

      {/* Abstract */}
      <Box>
        <Heading size='md' mb={3}>
          Abstract
        </Heading>
        <Text lineHeight='1.6' whiteSpace='pre-wrap'>
          {research.abstract}
        </Text>
      </Box>

      {/* Metadata */}
      <Box>
        <Heading size='sm' mb={2} color='gray.600'>
          Article Information
        </Heading>
        <VStack align='start' spacing={1} fontSize='sm' color='gray.600'>
          <Text>Added: {formatDate(research.createdAt.toDate())}</Text>
          {research.updatedAt && (
            <Text>Last updated: {formatDate(research.updatedAt.toDate())}</Text>
          )}
        </VStack>
      </Box>
    </VStack>
  )
}

export default ResearchContent
